import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { GLOBAL_ICONS } from '../../../../../util/vars';
import { Button } from '../../../../../components';

export const Edit = ({ onClick } : { onClick: () => void }):JSX.Element => {
  const { translate } = useI18n();

  return (
    <div className={'flex justify-end'}>
      <Button
        icon={GLOBAL_ICONS.edit}
        size={'sm'}
        align={'start'}
        asLink
        onClick={(event: React.SyntheticEvent) => {
          event.stopPropagation();

          onClick();
        }}
      >
        {translate('components.BUTTONS.EDIT')}
      </Button>
    </div>
  );
};
